var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepNotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leading-icon",
    clipPath: "url(#stepNotActive)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 4C7.584 4 4 7.584 4 12C4 16.416 7.584 20 12 20C16.416 20 20 16.416 20 12C20 7.584 16.416 4 12 4ZM9.832 15.432L6.96 12.56C6.648 12.248 6.648 11.744 6.96 11.432C7.272 11.12 7.776 11.12 8.088 11.432L10.4 13.736L15.904 8.232C16.216 7.92 16.72 7.92 17.032 8.232C17.344 8.544 17.344 9.048 17.032 9.36L10.96 15.432C10.656 15.744 10.144 15.744 9.832 15.432Z",
    fill: "#B4B5B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stepNotActive"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepNotActive);
export default __webpack_public_path__ + "static/media/stepNotActive.b93033801dd49539448b8f0fd6619a39.svg";
export { ForwardRef as ReactComponent };